<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    uid?: string;
    htmlMessage?: string;
    message?: string;
    title?: string;
    timer?: number;
    noCloseIcon?: boolean;
    variant?: string;
  }>(),
  {
    timer: 5,
    noCloseIcon: false,
    variant: 'primary',
  },
);

const emit = defineEmits<{
  (e: 'remove', uid: string | undefined): void;
}>();

const className = computed(() => `itp-notification--${props.variant}`);

function remove() {
  emit('remove', props.uid);
}
</script>

<template>
  <div class="itp-notification" :class="className">
    <div class="itp-notification__container">
      <div>
        <svg
          class="itp-notification__icon"
          width="14"
          height="20"
          viewBox="0 0 14 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.99346 19C3.99346 19.2652 4.09882 19.5196 4.28635 19.7071C4.47389 19.8946 4.72824 20 4.99346 20H8.99346C9.25868 20 9.51303 19.8946 9.70057 19.7071C9.8881 19.5196 9.99346 19.2652 9.99346 19V18H3.99346V19ZM6.99346 0C5.50444 0.00139123 4.05466 0.477563 2.85479 1.35932C1.65492 2.24108 0.767486 3.48248 0.321445 4.90312C-0.124597 6.32376 -0.106005 7.84963 0.374519 9.25898C0.855044 10.6683 1.77246 11.8877 2.99346 12.74V15C2.99346 15.2652 3.09882 15.5196 3.28635 15.7071C3.47389 15.8946 3.72824 16 3.99346 16H9.99346C10.2587 16 10.513 15.8946 10.7006 15.7071C10.8881 15.5196 10.9935 15.2652 10.9935 15V12.74C12.2145 11.8877 13.1319 10.6683 13.6124 9.25898C14.0929 7.84963 14.1115 6.32376 13.6655 4.90312C13.2194 3.48248 12.332 2.24108 11.1321 1.35932C9.93226 0.477563 8.48248 0.00139123 6.99346 0V0ZM9.84346 11.1L8.99346 11.7V14H4.99346V11.7L4.14346 11.1C3.26823 10.4928 2.60979 9.622 2.26409 8.61445C1.91839 7.60689 1.90351 6.51525 2.22161 5.49865C2.53971 4.48204 3.17417 3.59359 4.03252 2.96278C4.89087 2.33197 5.92824 1.99178 6.99346 1.99178C8.05867 1.99178 9.09605 2.33197 9.9544 2.96278C10.8128 3.59359 11.4472 4.48204 11.7653 5.49865C12.0834 6.51525 12.0685 7.60689 11.7228 8.61445C11.3771 9.622 10.7187 10.4928 9.84346 11.1V11.1Z"
          />
        </svg>
      </div>

      <div>
        <p v-if="title" class="itp-notification__title">{{ title }}</p>
        <p
          v-if="htmlMessage"
          class="itp-notification__message"
          v-html="htmlMessage"
        ></p>
        <p v-else class="itp-notification__message">{{ message }}</p>
      </div>

      <div class="itp-notification__closeButton" @click="remove()">
        <svg
          v-if="!noCloseIcon"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 1.00714L8.99286 0L5 3.99286L1.00714 0L0 1.00714L3.99286 5L0 8.99286L1.00714 10L5 6.00714L8.99286 10L10 8.99286L6.00714 5L10 1.00714Z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

